import { BREAKPOINTS, MQ_AND_BELOW } from "@customTypes/Breakpoints";
import { useEffect, useRef, useState } from "react";

export function getDevice(args: "tablet-landscape" | null): string {
  let windowWidth: number = 0;
  if (typeof window !== "undefined") {
    windowWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
  }

  if (windowWidth <= MQ_AND_BELOW.MOBILE) {
    return "mobile";
  } else if (windowWidth <= MQ_AND_BELOW.TABLET) {
    return "tablet";
  } else if (
    args === "tablet-landscape" &&
    windowWidth <= BREAKPOINTS.DESKTOP
  ) {
    return "tablet";
  } else if (windowWidth <= 1430) {
    return "desktop";
  }
  return "desktop-large";
}

/*
    useDevice() - Hook to get the device type
*/

export function useDevice(args: "tablet-landscape" | null = null) {
  const [device, setDevice] = useState("");
  const [currentDevice, setCurrentDevice] = useState<string | null>(null);

  const timer = useRef<number | null>(null);

  useEffect(() => {
    setDevice(getDevice(args));
  }, [args]);

  useEffect(() => {
    const onResize = () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        setDevice(getDevice(args));
      }, 300) as unknown as number;
    };

    window.addEventListener("resize", onResize);

    return () => window.removeEventListener("resize", onResize);
  }, [args, setDevice]);

  useEffect(() => {
    if (device !== currentDevice) {
      setCurrentDevice(device);
    }
  }, [currentDevice, device]);

  return currentDevice;
}
